import React, { createContext, useContext, useRef } from 'react'

// Provides a reference to a root div of the app.
const AppRootCompContext = createContext<React.RefObject<HTMLDivElement> | null>(null)

export const AppRootCompProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const divRef = useRef<HTMLDivElement>(null)

  return (
    <AppRootCompContext.Provider value={divRef}>
      <div ref={divRef}>
        {children}
      </div>
    </AppRootCompContext.Provider>
  )
}

export const useAppRootCompRef = () => useContext(AppRootCompContext)
